import { render, staticRenderFns } from "./SaveExportationForm.vue?vue&type=template&id=2b443d62&scoped=true&"
import script from "./SaveExportationForm.vue?vue&type=script&lang=js&"
export * from "./SaveExportationForm.vue?vue&type=script&lang=js&"
import style0 from "./SaveExportationForm.vue?vue&type=style&index=0&id=2b443d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b443d62",
  null
  
)

component.options.__file = "SaveExportationForm.vue"
export default component.exports